import { render, staticRenderFns } from "./baseList.vue?vue&type=template&id=563064f0&scoped=true"
import script from "./baseList.vue?vue&type=script&lang=ts"
export * from "./baseList.vue?vue&type=script&lang=ts"
import style0 from "./baseList.vue?vue&type=style&index=0&id=563064f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563064f0",
  null
  
)

export default component.exports